<script>
  import { External, M } from '../../external';
  import AuthorAvatar from '../../Common/AuthorAvatar.svelte';
  import getDateString from '../util/getDateString.js';

  export let comment,
    service,
    onCollapse,
    onExpand,
    hasRepliesFetched,
    onEditComment,
    onDeleteComment,
    onApproveComment;

  const thread = {
    state: 'expanded',
    toggle: () => {
      thread.state = thread.state === 'expanded' ? 'collapsed' : 'expanded';
      if (thread.state === 'expanded') {
        onExpand();
      } else {
        onCollapse();
      }
    }
  };

  const isCommentBelongToAdmin = service.isCommentBelongToAdmin(comment);

  let optionsBtn;
  const showOptions = () => {
    const target = External.$(optionsBtn);
    const options = [];
    if (!comment.approved) {
      options.push({ text: M.APPROVE, icon: 'fa-check', tag: 'approve' });
    }
    if (isCommentBelongToAdmin) {
      options.push({ text: M.EDIT, icon: 'fa-pencil', tag: 'edit' });
    }
    options.push({ text: M.DELETE, icon: 'fa-trash', tag: 'delete' });
    options.push({ text: M.COPY_COMMENT_ID, icon: 'fa-clipboard', tag: 'copy' });
    External.Tools.showTooltipOptions(target, options, async (target, idx, text, tag) => {
      switch (tag) {
        case 'approve':
          onApproveComment();
          break;
        case 'edit':
          onEditComment();
          break;
        case 'delete':
          onDeleteComment(comment);
          break;
        case 'copy':
          copyCommentIdToClipboard(comment.id);
          break;
      }
    });
  };

  export const toggle = () => {
    thread.toggle();
  };

  const copyCommentIdToClipboard = function (commentId) {
    External.Tools.copyToClipboard(commentId);
    External.Tools.showCornerMessage(1000, M.COPIED_TO_CLIPBOARD, External.Tools.TOOLTIP_TYPE_SUCCESS);
  };

  const getTimeAgo = (timestamp) => {
    const time = (Date.now() - timestamp * 1000) / 1000;
    if (time < 60) {
      return M.LESS_THAN_MINUTE_AGO;
    }
    if (time >= 60 && time < 60 * 60) {
      let conv = Math.floor(time / 60);
      if (conv === 1) {
        return M.MINUTE_AGO;
      }
      return External.format(M.MINUTES_AGO, 'x', conv);
    }
    if (time >= 60 * 60 && time < 60 * 60 * 24) {
      let conv = Math.floor(time / 60 / 60);
      if (conv === 1) {
        return M.HOUR_AGO;
      }
      return External.format(M.HOURS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 && time < 60 * 60 * 24 * 7) {
      let conv = Math.floor(time / 60 / 60 / 24);
      if (conv === 1) {
        return M.DAY_AGO;
      }
      return External.format(M.DAYS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 7 && time < 60 * 60 * 24 * 30) {
      let conv = Math.floor(time / 60 / 60 / 24 / 7);
      if (conv === 1) {
        return M.WEEK_AGO;
      }
      return External.format(M.WEEKS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 30 && time < 60 * 60 * 24 * 365) {
      let conv = Math.floor(time / 60 / 60 / 24 / 30);
      if (conv === 1) {
        return M.MONTH_AGO;
      }
      return External.format(M.MONTHS_AGO, 'x', conv);
    }
    if (time >= 60 * 60 * 24 * 365) {
      let conv = Math.floor(time / 60 / 60 / 24 / 365);
      if (conv === 1) {
        return M.YEAR_AGO;
      }
      return External.format(M.YEARS_AGO, 'x', conv);
    }

    return getDateString(timestamp);
  };
</script>

<header class="col20 f-lef flex align-center space-between">
  <div class="flex align-center">
    <div class="circle-post-author flex align-center">
      <AuthorAvatar author={comment.author} />
      <span class="circle-post-author-name">{comment.author.name}</span>
      <span title={getDateString(comment.timestamp)} class="circle-post-time">{getTimeAgo(comment.timestamp)}</span>
    </div>
    {#if !comment.approved}
      <div style="cursor: pointer;" on:click={onApproveComment} class="circle-post-badge moderator">{M.APPROVE}</div>
    {/if}
  </div>
  <div class="flex-none">
    <!-- Collapse / Expand a comment thread -->
    <div
      class:none={!hasRepliesFetched}
      on:click={thread.toggle}
      class="circle-round-btn circle-effect f-left mr-5 collapse">
      {#if thread.state === 'collapsed'}
        <svg xmlns="http://www.w3.org/2000/svg" class="expand-icon" height="24" viewBox="0 -960 960 960" width="24">
          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
        </svg>
      {:else}
        <svg xmlns="http://www.w3.org/2000/svg" class="collapse-icon" height="24" viewBox="0 -960 960 960" width="24">
          <path d="M200-440v-80h560v80H200Z" />
        </svg>
      {/if}
    </div>
    <!-- Collapse / Expand a comment thread END -->
    <!-- Comment Options -->
    <div bind:this={optionsBtn} on:click={showOptions} class="circle-round-btn circle-effect f-left">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </svg>
    </div>
    <!-- Comment Options END-->
  </div>
</header>
